const apiUrl = process.env.URL_API || "http://localhost:8080";

// Função para obter o token JWT do localStorage
const getJwtToken = () => {
    const token = localStorage.getItem('jwtToken');
    if (!token || token.split('.').length !== 3) {
        throw new Error('Invalid JWT token');
    }
    return token;
};
const changeStatusAgendamento = async (id) => {
    const token = getJwtToken(); // Obtém o token
    try {
        const data = await fetch(`${apiUrl}/clinica-integrada/gm/atendimentos/${id}/cancelar`, {
            method: 'PATCH',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        // Verifique se o conteúdo da resposta é JSON ou texto
        const result = data.headers.get('Content-Type')?.includes('application/json')
            ? await data.json()
            : await data.text();

        if (data.ok) {
            return result; // Retorna o resultado, seja texto ou JSON
        } else {
            throw new Error('Erro ao cancelar o agendamento');
        }
    } catch (error) {
        console.error('Erro na requisição:', error);
        return undefined; // Retorna undefined em caso de erro
    }
};



const getEspecialidades = async (id) => {
    const token = getJwtToken(); // Obtém o token
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/especialidades?id=${id}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    })
        .then(res => res.json())
        .catch(() => "NO DATA");

    return data;
};

const getMedicos = async (id, idUnidade) => {
    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/medicos?id=${id}&idUnidade=${idUnidade}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res)
        .catch(res => res);

    if (data.status !== 200) {
        return "NO DATA";
    }
    return data.json();
};

const getConvenios = async (idProcedimentos) => {
    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/convenios?idProcedimento=${+idProcedimentos}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res)
        .catch(res => res);

    if (data.status !== 200) {
        return "NO DATA";
    }
    return data.json();
};

const getDias = async (idclinica = 2, idmedico, mes, ano) => {
    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/dias?idclinica=${idclinica}&idmedico=${idmedico}&mes=${mes}&ano=${ano}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res)
        .catch(res => res);

    if (data.status !== 200) {
        return [];
    }
    return data.json();
};

const getHorarios = async (dados) => {
    const token = getJwtToken();
    const dataConv = new Date().toLocaleDateString();
    const horaConv = new Date().toLocaleTimeString();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/horarios?idmedico=${dados.idmedico}&data=${dados.date}&idunidade=${dados.idunidade}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .catch(res => res);

    if (data.status === 400) {
        return [];
    }

    const dataFilterBlock = data.filter((e)=> e.Block === false);
    const dataFilterHorario = dataFilterBlock.filter((e) => e.Horario > horaConv);
    if (dados.date === dataConv) {
        return dataFilterHorario;
    }
    return dataFilterBlock;
};

const getAtendimentos = async (cpf) => {
    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/atendimentos?cpf=${cpf}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .catch(res => res);

    if (data.length !== 0) {
        return filterObjectsByYear(data);
    }
    return data;
};

const setAtendimento = async (user) => {
    const token = getJwtToken();
    let dateOptional = user.horario ? user.horario : '00:00';
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/concluir?idmedico=${user.idMedico}&data=${user.data}&cpf=${user.codPaciente}&nomePaciente=${user.nomePaciente}&idUnidade=${user.unidade}&idProcedimento=${user.idProcedimento}&horario=${dateOptional}&telefone=${user.telefone}`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res)
        .catch(res => res);

    return data;
};

const getUnidades = async () => {

    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/unidades`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .catch(res => res);

    return data;
};

const getMedicosUnidade = async (idUnidade) => {
    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/medicosunidade?id=${idUnidade}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .catch(res => res);

    return data;
};

const getProcedimento = async (idMedico) => {
    const token = getJwtToken();
    const data = await fetch(`${apiUrl}/clinica-integrada/gm/procedimentos?idmedico=${idMedico}`, {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .catch(res => res);

    return data;
};

function filterObjectsByYear(arr) {
    const filteredObjects = arr.filter(obj => {
        const yearnow = new Date().getFullYear();
        const year = new Date(obj.data).getFullYear();
        return year === yearnow;
    });
    return filteredObjects;
}

export const ApiGestorMed = {
    getEspecialidades,
    getAtendimentos,
    setAtendimento,
    getMedicos,
    getDias,
    getHorarios,
    getUnidades,
    getMedicosUnidade,
    getProcedimento,
    changeStatusAgendamento,
    getConvenios
};
